export default "__VITE_ASSET__3e884c7e__"